module.exports = __webpack_public_path__ + "static/media/successDarkGreen.82acfcc4.svg";